import ImageWithInitials from "../../../Utils/ImageWithInitials";
import ImageLoader from "../ImageLoader";
import './user-info-row.styles.scss';

const UserInfoRow = ({ client }) => {
  return (
    <div key={client.ObjectId} className="user-info-row">
      <ImageLoader 
        src={client?.Avatar}
        width={32}
        height={32}
        alt="avatar"
        noImageComponent={(
          <ImageWithInitials
            initials={client?.initials}
            width={32}
            background={"purple"}
          />
        )}
      />
      <div>
        <h3 className="m-0 f-black f-14 line-height-22 f-500">{client?.fullName}</h3>
        <h3 className="m-0 f-grey f-12 line-height-18 f-400">{client?.userName}</h3>
      </div>
    </div>
  );
}

export default UserInfoRow;
